import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=760eee0c&scoped=true"
import script from "./ProductTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=760eee0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760eee0c",
  null
  
)

export default component.exports